import { Content, Item, Root, Trigger } from '@radix-ui/react-accordion';
import type { AccordionProps } from './Accordion.types';

const Accordion = ({
  accordionItems,
  defaultValue,
  value,
  onItemSelect,
  disabled,
  extraClassNames,
  testId,
}: AccordionProps) => {
  return (
    <Root
      className={`tw:rounded-md tw:w-full tw:focus-visible:outline-none ${extraClassNames || ''}`}
      type="single"
      defaultValue={defaultValue}
      value={value}
      collapsible
      data-testid={testId}
      onValueChange={(_value) => onItemSelect(_value)}>
      {accordionItems.map((item) => (
        <Item className="tw:p-0 tw:flex tw:flex-col tw:w-full" key={item.value} disabled={disabled} value={item.value}>
          <Trigger
            disabled={disabled}
            className="tw:w-full tw:cursor-default tw:focus-visible:outline-none tw:bg-transparent">
            {item.trigger}
          </Trigger>
          <Content
            className={`tw:data-[state=open]:animate-slideDown tw:data-[state=closed]:animate-slideUp tw:overflow-hidden tw:focus-visible:outline-none ${
              item.contentClassNames || ''
            }`}>
            {item.content}
          </Content>
        </Item>
      ))}
    </Root>
  );
};

export default Accordion;
